/**
 *
 * FBSectionFieldsSeparator
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// antd component
//import { Card } from 'antd';
//const { Meta } = Card;

// icons
import CustomIcons from 'components/CustomIcons';
//import defaultUnitImage from 'images/default.jpg';
 // garbage
function FBSectionFieldsSeparator({
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames(
    'tcf-fb-section-fields__separator',
    className,
  );

  return <div className={childClassNames}>FBSectionFieldsSeparator</div>;
}

FBSectionFieldsSeparator.defaultProps = {};
FBSectionFieldsSeparator.propTypes = {};

export default memo(FBSectionFieldsSeparator);
